import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import VueI18n from 'vue-i18n';
import echarts from './utils/echarts.js';
import 'element-ui/lib/theme-chalk/index.css';
import './styles/production-reference.css'
import i18n from './common/lang';
import heartbeatManager from './utils/heartbeat';
// import { initializeMetaTags, updateMetaTagsForRoute } from './utils/metaTags';

// import enLocale from 'element-ui/lib/locale/lang/en';
// import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false
/** 国际化 **/
// Vue.use(VueI18n);
// Vue.use(ElementUI, {
//   i18n: (key, value) => i18n.t(key, value)
// });
// const i18n = new VueI18n({
//   locale: 'en',
//   messages: {
//     'zh': Object.assign(require('@/common/lang/zh'), zhLocale),
//     'en': Object.assign(require('@/common/lang/en'), enLocale),
//   }
// });

// 应用启动前初始化登录状态
function initializeAuthState() {
  const token = localStorage.getItem('token');
  const userInfo = localStorage.getItem('userInfo');
  const isLogin = localStorage.getItem('isLogin');

  // 如果有完整的登录信息，确保store状态正确
  if (token && userInfo && isLogin === 'true') {
    try {
      const parsedUserInfo = JSON.parse(userInfo);
      store.commit('setToken', token);
      store.commit('set_userInfo', parsedUserInfo);
      store.commit('set_isLogin', true);
    } catch (error) {
      console.error('解析用户信息失败，清除登录状态:', error);
      // 清除无效的登录状态
      localStorage.removeItem('token');
      localStorage.removeItem('userInfo');
      localStorage.removeItem('isLogin');
      store.commit('set_isLogin', false);
    }
  } else {
    // 清除不完整的登录状态
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('isLogin');
    store.commit('set_isLogin', false);
  }
}

// 初始化登录状态
initializeAuthState();

// 初始化网络监听器
async function initNetworkWatcher() {
  try {
    const { initNetworkWatcher } = await import('@/plugin/chain/eth')
    await initNetworkWatcher()
  } catch (error) {
    console.warn('网络监听器初始化失败:', error)
  }
}

const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')

// 将Vue实例挂载到window，供网络监听器使用
window.vm = app

// 🎯 启动心跳管理器
if (store.state.isLogin) {
  heartbeatManager.start()
}

// 监听登录状态变化
store.watch(
  (state) => state.isLogin,
  (newValue) => {
    if (newValue) {
      console.log('🎯 [Main] 用户登录，启动心跳')
      heartbeatManager.start()
    } else {
      console.log('🎯 [Main] 用户登出，停止心跳')
      heartbeatManager.stop()
    }
  }
)

// 页面加载完成后初始化网络监听
initNetworkWatcher()
